var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loginCallback"},[(_vm.state == 'logging_in')?_c('h1',[_vm._v("Logging you in...")]):_vm._e(),(_vm.state == 'failed')?_c('h1',[_vm._v("Login failed.")]):_vm._e(),(_vm.state == 'failed')?_c('p',[_vm._v(" Please log in to Circul8 via the account menu. ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }